module.exports = __webpack_public_path__ + "static/28-global-platinum-front@2x-fd97a8eebc3efda9b40c086d874347f5.png";